import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from './AuthModal';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { user, signOut } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem('cart') || '[]');
      const total = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
      setCartCount(total);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('cartUpdated', updateCartCount);
    updateCartCount();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('cartUpdated', updateCartCount);
    };
  }, []);

  const handleLogout = async () => {
    await signOut();
    setShowUserMenu(false);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-gray-900/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex items-center gap-3 cursor-pointer">
              <div className="w-12 h-12 bg-gradient-to-r from-neon-pink to-neon-cyan rounded-lg flex items-center justify-center">
                <i className="ri-gamepad-line text-2xl text-white"></i>
              </div>
              <span className="text-2xl font-black text-white">
                ROX<span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-pink to-neon-cyan">GAMER</span>
              </span>
            </a>

            <div className="hidden md:flex items-center gap-8">
              <a href="/" className="text-white hover:text-neon-cyan transition-colors font-semibold cursor-pointer">
                Início
              </a>
              <a href="/catalogo" className="text-white hover:text-neon-cyan transition-colors font-semibold cursor-pointer">
                Catálogo
              </a>
              <a href="/monte-seu-pc" className="text-white hover:text-neon-cyan transition-colors font-semibold cursor-pointer">
                Monte seu PC
              </a>
            </div>

            <div className="flex items-center gap-4">
              <a href="/cart" className="relative text-white hover:text-neon-cyan transition-colors cursor-pointer">
                <i className="ri-shopping-cart-line text-2xl"></i>
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-gradient-to-r from-neon-pink to-neon-cyan text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </a>

              {user ? (
                <div className="relative">
                  <button
                    onClick={() => setShowUserMenu(!showUserMenu)}
                    className="flex items-center gap-2 bg-gradient-to-r from-neon-pink to-neon-cyan text-white px-4 py-2 rounded-lg font-semibold hover:shadow-neon-pink transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-user-line"></i>
                    Minha Conta
                  </button>

                  {showUserMenu && (
                    <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-xl border border-gray-700 overflow-hidden">
                      <a
                        href="/account"
                        className="block px-4 py-3 text-white hover:bg-gray-700 transition-colors cursor-pointer"
                      >
                        <i className="ri-user-settings-line mr-2"></i>
                        Meus Dados
                      </a>
                      <a
                        href="/account"
                        className="block px-4 py-3 text-white hover:bg-gray-700 transition-colors cursor-pointer"
                      >
                        <i className="ri-shopping-bag-line mr-2"></i>
                        Meus Pedidos
                      </a>
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-3 text-red-400 hover:bg-gray-700 transition-colors cursor-pointer"
                      >
                        <i className="ri-logout-box-line mr-2"></i>
                        Sair
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <button
                  onClick={() => setShowAuthModal(true)}
                  className="bg-gradient-to-r from-neon-pink to-neon-cyan text-white px-6 py-2 rounded-lg font-semibold hover:shadow-neon-pink transition-all whitespace-nowrap cursor-pointer"
                >
                  Login
                </button>
              )}
            </div>
          </div>
        </div>
      </nav>

      <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
    </>
  );
}
